import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/anne-sophie-grell")({
  head: () => buildRouteHead("/anne-sophie-grell", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/team", replace: true });
  },
});
